import localization from '../../../../shared/strings';

const autoMappedFieldLabels = localization.PRODUCT_INFO.autoMappedFieldLabels;

export const resolveAggregatedDialogLabel = ({
  fieldKey,
  fieldLabel,
  dialogLabel,
}) => {
  if (typeof dialogLabel === 'string' && dialogLabel.length > 0) {
    return dialogLabel;
  }

  if (typeof fieldLabel === 'string' && fieldLabel.length > 0) {
    return fieldLabel;
  }

  if (fieldKey && autoMappedFieldLabels[fieldKey]) {
    return autoMappedFieldLabels[fieldKey];
  }

  return fieldKey || 'field';
};

export default resolveAggregatedDialogLabel;
